<script setup>
import { ref } from 'vue';
import http from "@/axios-config";

const email = ref(null);
const has_error = ref(false);
const complete = ref(false);

async function reset() {
    const response = await http.post(`/api/auth/reset`, { email: email.value });

    if (response.status == 200) {
        has_error.value = false;
        complete.value = true;
    } else {
        has_error.value = true;
    }
}

</script>

<template>
    <div class="login" style="background-image:url('/img/login-bg.png')">
        <div class="login-form">
            <h1 class="welcome-message">
                <span class="first-line">Reset Password</span>
            </h1>
            <div v-if="has_error">
                <p class="error-message">
                    A password reset link has been sent to your email address.
                </p>
            </div>
            <form autocomplete="off" @submit.prevent="reset" method="post">
                <div class="login-email">
                    <label for="email">Email</label>
                    <input type="email" v-model="email" required />
                </div>
                <button class="login-submit" type="submit">
                    Reset Password
                </button>
            </form>

            <p class="request-received" v-if="complete">Password reset request received. Please check your email for
                instructions.</p>
        </div>
    </div>
</template>

<style scoped lang="scss">
.login {
    background-size: cover;
    background-repeat: no-repeat;
}

.login-form {
    @media (max-width:600px) {
        width: 100%;

        h1 {
            padding: 0 20px;
        }
    }
}

.request-received {
    margin-top: 20px;
    font-size: 14px;
    display: block;
    text-align: center;
}
</style>
